import { updateSession } from '@sentry/hub';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
export var SentryTeam;
(function (SentryTeam) {
    SentryTeam["Unknown"] = "unknown";
    SentryTeam["Core"] = "core";
    SentryTeam["Routing"] = "routing-and-presence";
    SentryTeam["Insights"] = "insights";
    SentryTeam["Ecosystem"] = "ecosystem";
    SentryTeam["Partners"] = "partners";
    SentryTeam["Channels"] = "channels";
    SentryTeam["Messaging"] = "messaging";
    SentryTeam["Platform"] = "platform";
    SentryTeam["AI"] = "ai";
    SentryTeam["Conversations"] = "conversations";
})(SentryTeam || (SentryTeam = {}));
const IGNORE_UNLESS_FATAL = [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
];
export function sentryInit() {
    Sentry.init({
        dsn: 'https://9a661fe0304d4712921ed43f509c3915@sentry.io/99229',
        environment: SENTRY_ENV,
        release: VERSION,
        // This enables automatic instrumentation (highly recommended), but is not
        // necessary for purely manual usage
        integrations: [
            new BrowserTracing(),
            new Sentry.Integrations.Breadcrumbs({
                console: false,
            }),
        ],
        // To set a uniform sample rate. Disable to 0 by 6 Oct 2022 because of usage.
        tracesSampleRate: 0.0,
        beforeSend: (event, hint) => {
            var _a;
            const values = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values;
            event.transaction = location.pathname
                .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '/<uuid>')
                .replace(/\/\d+/g, '/<digits>');
            if (values === null || values === void 0 ? void 0 : values.length) {
                const exception = values[0];
                const mechanism = exception.mechanism;
                if (event.level === 'fatal' && mechanism) {
                    // override sentry marking every event as handled
                    mechanism.handled = false;
                }
                if (event.level !== 'fatal' && exception.value) {
                    if (IGNORE_UNLESS_FATAL.includes(exception.value)) {
                        return null;
                    }
                    // Add the event value so don't track it a second time.
                    IGNORE_UNLESS_FATAL.push(exception.value);
                }
            }
            return event;
        },
    });
}
export function sentrySetup(params) {
    Sentry.setUser({
        id: params.user.id,
    });
    Sentry.setContext('Organization', {
        connection_id: params.connectionId,
        org_avatar_url: params.organization.avatar_url,
        organization: params.organization.name,
        subdomain: params.organization.subdomain,
        org_id: params.organization.id,
    });
    Sentry.setTag('team', SentryTeam.Unknown);
}
export function sentrySetFatalScope(scope) {
    const session = scope.getSession();
    if (session) {
        updateSession(session, { status: 'crashed' });
        scope.setSession(session);
        scope.setLevel('fatal');
    }
}
export { Sentry };
